import React from 'react';
import '../styles/PatientEducation.css';

const PatientEducation = () => {
  return (
    <div className="education-container">
      <div className="education-header">
        <h2>Educational Resources</h2>
        <p>Access helpful resources and learning materials</p>
      </div>
      
      <div className="education-content">
        <div className="education-placeholder">
          <div className="education-coming-soon">
            <p>Educational content coming soon</p>
            <p>We're working on bringing you valuable resources to support your health journey.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientEducation;
